import * as types from '../mutation-types'
import Vue from 'vue'

const state = {
  addPaymentData: {}, // 新加的回款计划
  editPaymentData: {}, // 已经有的回款计划
  paymentNoMax: {}, // 回款编号的最大后缀
  paymentForm: {}, // 要提交的回款计划
  isCheckPayment: {},
  editPaymentMoney: {},
  paymentType: ''
}

// getters
const getters = {
  addPaymentData: state => state.addPaymentData[state.paymentType] || [],
  editPaymentData: state => state.editPaymentData[state.paymentType] || [],
  paymentNoMax: state => state.paymentNoMax[state.paymentType] || 0,
  paymentForm: state => state.paymentForm[state.paymentType] || [],
  isCheckPayment: state => state.isCheckPayment[state.paymentType] || false,
  editPaymentMoney: state => state.editPaymentMoney[state.paymentType] || [],
  paymentType: state => state.paymentType
}

// actions
const actions = {
  setAddPaymentData ({ commit }, payload) {
    commit(types.ADD_PAYMENT_DATA, payload)
  },
  setEditPaymentData ({ commit }, payload) {
    commit(types.EDIT_PAYMENT_DATA, payload)
  },
  setPaymentNoMax ({ commit }, payload) {
    commit(types.PAYMENT_NO_MAX, payload)
  },
  setPaymentForm ({ commit }, payload) {
    commit(types.SET_PAYMENT_FORM, payload)
  },
  checkPayment ({ commit }, payload) {
    commit(types.CHECK_PAYMENT, payload)
  },
  setEditPaymentMoney ({ commit }, payload) {
    commit(types.SET_EDIT_PAYMENTMONEY, payload)
  },
  initPayment ({ commit }, payload) {
    commit(types.INIT_PAYMENT, payload)
  },
  setPaymentType ({ commit }, payload) {
    commit(types.SET_PAYMENT_TYPE, payload)
  }
}

// mutations
const mutations = {
  [types.ADD_PAYMENT_DATA] (state, status) {
    Vue.set(state.addPaymentData, state.paymentType, status)
  },
  [types.EDIT_PAYMENT_DATA] (state, status) {
    Vue.set(state.editPaymentData, state.paymentType, status)
  },
  [types.PAYMENT_NO_MAX] (state, status) {
    Vue.set(state.paymentNoMax, state.paymentType, status)
  },
  [types.SET_PAYMENT_FORM] (state, status) {
    Vue.set(state.paymentForm, state.paymentType, status)
  },
  [types.CHECK_PAYMENT] (state, status) {
    Vue.set(state.isCheckPayment, state.paymentType, status)
    if (!status) {
      Vue.set(state.paymentForm, state.paymentType, [])
    }
  },
  [types.SET_EDIT_PAYMENTMONEY] (state, status) {
    let isUpdate = true
    state.editPaymentMoney[state.paymentType].forEach(element => {
      if (element.id === status.id) {
        isUpdate = false
        element.money = status.money
      }
    })
    if (isUpdate) {
      state.editPaymentMoney[state.paymentType].push(status)
    }
  },
  [types.INIT_PAYMENT] (state, status) {
    Vue.set(state.addPaymentData, state.paymentType, [])
    Vue.set(state.editPaymentData, state.paymentType, [])
    Vue.set(state.paymentNoMax, state.paymentType, 0)
    Vue.set(state.paymentForm, state.paymentType, [])
    Vue.set(state.isCheckPayment, state.paymentType, false)
    Vue.set(state.editPaymentMoney, state.paymentType, [])
  },
  [types.SET_PAYMENT_TYPE] (state, status) {
    state.paymentType = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/payment.js